/* tslint:disable */
/* eslint-disable */
export enum TwoFactorProvider {
  Email = 'email',
  Authenticator = 'authenticator'
}
